import { faRotate } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const renderFilterCellDocsAdm = (col, idx, context) => {
  switch (col.admFilterType) {
    case "Admin actions": {
      const { colorFilterAction, page, t, handleRelaunchClickInstance } = context;
      if (page !== "DocStatus") {
        return (
          <th key={`actions-${idx}`} style={{ backgroundColor: colorFilterAction }}>
            <button
              className="btn bg-light text-hover-blue"
              title={t("Relaunch docs instance status")}
              onClick={handleRelaunchClickInstance}
            >
              <FontAwesomeIcon icon={faRotate} className="fa-copy" />
            </button>
          </th>
        );
      } else {
        return (
          <th style={{backgroundColor: colorFilterAction}}></th>
        )
      }
    }
    default:
      return (
        <th
          key={`filter-default-${idx}`}
          className="style_tbody_th"
          style={{ backgroundColor: context.colorFilterAction }}
        ></th>
      );
  }
};
